import firebase from 'firebase/app';

export const SaveIntVal = (intVal, classified) => {

    firebase.firestore()
    .collection('v2InterestValues')
    .doc(intVal.toString().toLowerCase())
    .set({
        intVal: intVal.toString().toLowerCase(),
        classified: classified
    })
}
 